import { createElement, useLayoutEffect } from 'react';
import { useLocation, useSearch } from 'wouter';

const signals = new Map<string, boolean>();
type CoverWindow = Window & {
  newsiteCommerceEntry?: boolean;
  storefrontLoadingCover?: { begin(key: string, heavy: boolean): void; setReady(key: string, ready: boolean): void };
};

export function NewsiteCommerceEntry() {
  const [location] = useLocation();
  const search = useSearch();
  useLayoutEffect(() => {
    const target = window as CoverWindow;
    if (!target.newsiteCommerceEntry) return;
    signals.clear();
    const heavy = /^\/shop\/(?:boxes(?:\/|$)|checkout\/)/.test(location);
    target.storefrontLoadingCover?.begin(`commerce:${location}?${search}`, heavy);
    if (!heavy) target.storefrontLoadingCover?.setReady(`commerce:${location}?${search}`, true);
  }, [location, search]);
  return null;
}

export function NewsiteCommerceRecovery() {
  if (!(window as CoverWindow).newsiteCommerceEntry) return null;
  return createElement('p', { className: 'mt-4 flex gap-4 underline' },
    createElement('a', { href: window.location.href }, 'Reload shop'),
    createElement('a', { href: '/newsite/' }, 'Return to EverydayBullion'));
}

/** No effect outside the explicitly marked Newsite Commerce handoff. */
export function useNewsiteCommerceReadiness(contributor: 'layout' | 'primary' | 'fallback', ready: boolean) {
  const [location] = useLocation();
  const search = useSearch();
  useLayoutEffect(() => {
    const target = window as CoverWindow;
    if (!target.newsiteCommerceEntry) return;
    signals.set(contributor, ready);
    target.storefrontLoadingCover?.setReady(`commerce:${location}?${search}`,
      signals.get('layout') === true && (signals.get('primary') === true || signals.get('fallback') === true));
    return () => { signals.delete(contributor); };
  }, [contributor, ready, location, search]);
}
